/*
    🔥 EJE DISPOSICIÓN DEL HEADER

    Eje APARTE del nivel estético:
      LEVEL__LAYOUT_STYLE_TEMPLATE  -> forma (radios, bordes, tipografía)
      LEVEL__HEADER_*_TEMPLATE      -> dónde va la navegación y cómo colapsa

    Se combinan libremente: header 5 con estética 9 es válido.

    ⚠️ El template 1 es EXACTAMENTE el header que ya tenías.
       Los otros 10 se suman sin tocarlo.

    ⚠️ Las utilidades (iconos) SIEMPRE están visibles en la barra.
       Lo único que colapsa son los items de navegación.

    brand    : dónde se ancla la marca
    nav      : dónde vive la navegación en escritorio
    collapse : en qué se convierte cuando colapsa (mobile o always)
    always   : true = colapsada también en escritorio
*/

export const HEADER_TEMPLATES = [

    { id: 1, label: 'Clásico — nav a la derecha', brand: 'start', nav: 'inline_end', collapse: 'dropdown', always: false },

    { id: 2, label: 'Centrado — nav al medio', brand: 'start', nav: 'inline_center', collapse: 'dropdown', always: false },

    { id: 3, label: 'Marca al medio', brand: 'center', nav: 'inline_start', collapse: 'offcanvas', always: false },

    { id: 4, label: 'Doble fila', brand: 'start', nav: 'row_below', collapse: 'dropdown', always: false },

    { id: 5, label: 'Offcanvas siempre', brand: 'start', nav: 'hidden', collapse: 'offcanvas', always: true },

    { id: 6, label: 'Sidebar lateral', brand: 'start', nav: 'hidden', collapse: 'sidebar', always: true },

    { id: 7, label: 'Compacto — scroll horizontal', brand: 'start', nav: 'inline_scroll', collapse: 'dropdown', always: false },

    { id: 8, label: 'Mega menú', brand: 'start', nav: 'inline_end', collapse: 'offcanvas', always: false },

    { id: 9, label: 'Minimal — nav en dropdown', brand: 'start', nav: 'hidden', collapse: 'dropdown', always: true },

    { id: 10, label: 'Apilado — marca arriba', brand: 'center', nav: 'row_below', collapse: 'offcanvas', always: false },

    { id: 11, label: 'Flotante', brand: 'start', nav: 'inline_end', collapse: 'dropdown', always: false },

];

export const HEADER_TEMPLATE_IDS = HEADER_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = HEADER_TEMPLATES[0];

export const onResolveHeaderTemplate = (id) => (
    HEADER_TEMPLATES.find((item) => item.id === Number(id)) ?? FALLBACK_TEMPLATE
);
